/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The granted permission group of the token.
 */
export type ActiveScopeGroup =
  (typeof ActiveScopeGroup)[keyof typeof ActiveScopeGroup];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActiveScopeGroup = {
  CATALOG_READ: "CATALOG_READ",
  ORDER_CREATE: "ORDER_CREATE",
  ORDER_INVOICE_READ: "ORDER_INVOICE_READ",
  ORDER_DESPATCH_ADVICE_READ: "ORDER_DESPATCH_ADVICE_READ",
  ORDER_OTHER_READ: "ORDER_OTHER_READ",
  SUPPLIER: "SUPPLIER",
  ERP_SUPPLIER: "ERP_SUPPLIER",
} as const;
